module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "form_body clear_fix"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "box_field"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.sendForm(_vm.data)
      }
    }
  }, [_vm._l((_vm.form.fields), function(field) {
    return _c('div', {
      staticClass: "field_row"
    }, [(field.type != 'textarea') ? _c('div', {
      staticClass: "field_name"
    }, [_vm._v(_vm._s(field.label))]) : _vm._e(), _vm._v(" "), _c('label', [(field.type == 'text') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.data[field.label]),
        expression: "data[field.label]"
      }],
      staticClass: "field_item field_item_text",
      attrs: {
        "name": field.uniname,
        "type": "text"
      },
      domProps: {
        "value": (_vm.data[field.label])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data, field.label, $event.target.value)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('label', [(field.type == 'number') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.data[field.label]),
        expression: "data[field.label]"
      }],
      staticClass: "field_item field_item_number",
      attrs: {
        "name": field.uniname,
        "type": "number"
      },
      domProps: {
        "value": (_vm.data[field.label])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data, field.label, $event.target.value)
        }
      }
    }) : _vm._e()]), _vm._v(" "), (field.type == 'checkbox') ? _c('div', {
      staticClass: "checkbox_wrap"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.data[field.label]),
        expression: "data[field.label]"
      }],
      staticClass: "field_item field_item_checkbox",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.data[field.label]) ? _vm._i(_vm.data[field.label], null) > -1 : (_vm.data[field.label])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.data[field.label],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.data[field.label] = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.data[field.label] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.data, field.label, $$c)
          }
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (field.type == 'textarea') ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.data[field.label]),
        expression: "data[field.label]"
      }],
      staticClass: "field_item field_item_textarea",
      attrs: {
        "title": "description",
        "placeholder": field.label
      },
      domProps: {
        "value": (_vm.data[field.label])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data, field.label, $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (field.type != 'textarea'),
        expression: "field.type !='textarea'"
      }],
      staticClass: "field_last_name"
    }, [_vm._v(_vm._s(field.si))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "field_row bort"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data['Комментарий']),
      expression: "data['Комментарий']"
    }],
    staticClass: "field_item field_item_textarea",
    attrs: {
      "placeholder": "Комментарий",
      "cols": "30",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.data['Комментарий'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, 'Комментарий', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_viewer_select_file clear_fix"
  }, [_c('div', {
    staticClass: "field_row"
  }, [_c('div', {
    staticClass: "field_name"
  }, [_vm._v("Прикрепить файл")]), _vm._v(" "), _c('input', {
    staticClass: "type_file",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.getDocument
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "field_last_name"
  })]), _vm._v(" "), _c('input', {
    staticClass: "saveButton",
    attrs: {
      "type": "submit",
      "value": "Сохранить"
    }
  })])], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wg_left_column ready_analyzes_wrap"
  }, [_c('div', {
    staticClass: "analyze_box"
  }, [_c('p', {
    staticClass: "analyze_name"
  }, [_vm._v("Название анализа")]), _vm._v(" "), _c('p', {
    staticClass: "analyze_date"
  }, [_vm._v("07.04.2017")])]), _vm._v(" "), _c('div', {
    staticClass: "analyze_box"
  }, [_c('p', {
    staticClass: "analyze_name"
  }, [_vm._v("Название анализа")]), _vm._v(" "), _c('p', {
    staticClass: "analyze_date"
  }, [_vm._v("07.04.2017")])]), _vm._v(" "), _c('div', {
    staticClass: "analyze_box"
  }, [_c('p', {
    staticClass: "analyze_name"
  }, [_vm._v("Название анализа")]), _vm._v(" "), _c('p', {
    staticClass: "analyze_date"
  }, [_vm._v("07.04.2017")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0634490"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormViewer.vue
// module id = 652
// module chunks = 0